import templateUrl from './admin-user-edit-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    user: '<',
    onUserChanged: '&'
  },
  controller: class AdminUserEditFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.user = this.user || {};
    }

    onSubmit() {
      this.onUserChanged(
        this.EventEmitter({
          user: this.user
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-edit-form/admin-user-edit-form.component.js